import { _ as __rest, a as __assign } from '../tslib.es6-9c588127.js';
import React from 'react';

var Spacer = function Spacer(_a) {
  var _b = _a.multiply,
      multiply = _b === void 0 ? 1 : _b,
      _c = _a.type,
      type = _c === void 0 ? 'around' : _c,
      children = _a.children,
      _d = _a.className,
      className = _d === void 0 ? '' : _d,
      rest = __rest(_a, ["multiply", "type", "children", "className"]);

  if (type === 'around') {
    return React.createElement("div", __assign({
      className: "around" + multiply + " " + className
    }, rest));
  }

  return React.createElement("div", __assign({
    className: "within" + multiply + " " + className
  }, rest), children);
};

export { Spacer };